import { FC } from 'react';
import { ThemeMode } from '../../global-state/themeContext';
import { ContainerV2 } from '../../stories/atoms/containerV2/ContainerV2';
import { Icon, Icons } from '../../stories/atoms';
import { StyledProfileImage } from './Profile.styles';

type ProfileAvatarProps = {
  avatarUrl?: string;
  isMobile?: boolean;
  mode: ThemeMode;
  onEditAvatar: () => void;
};

export const ProfileAvatar: FC<ProfileAvatarProps> = ({ avatarUrl, isMobile, mode, onEditAvatar }) => (
  <ContainerV2 position="relative" display="inline-block">
    <ContainerV2
      data-testid="profile-avatar"
      width={isMobile ? [12] : [26]}
      height={isMobile ? [12] : [26]}
      borderRadius={[16]}
      overflow="hidden"
      backgroundColor={mode === 'dark' ? 'backgroundSelectedHover' : 'backgroundTableHeader'}
      alignItems="center"
      justifyContent="center"
      display="flex"
      cursor="pointer"
      onClick={onEditAvatar}
    >
      {avatarUrl ? (
        <StyledProfileImage
          src={`${avatarUrl}${process.env.REACT_APP_CDN_TOKEN}`}
          alt="profile-avatar"
          isMobile={isMobile}
        />
      ) : (
        <Icon
          data-testid="default-profile-icon"
          icon={Icons.PROFILE}
          size={isMobile ? 'medium' : 'large'}
          color="primary"
        />
      )}
    </ContainerV2>

    <ContainerV2
      position="absolute"
      bottom="0"
      right="0"
      shadow
      cursor="pointer"
      onClick={onEditAvatar}
      borderRadius={[50]}
      padding={isMobile ? [0] : [1]}
      backgroundColor={mode === 'dark' ? 'backgroundPaperDark' : 'white'}
    >
      <Icon icon={Icons.EDIT} size="small" />
    </ContainerV2>
  </ContainerV2>
);
